import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductState } from './product.reducers';

export const selectProductState = createFeatureSelector<ProductState>('product');

/** Returns the entire ProductState (backwards compat — existing consumers use this) */
export const selectProduct = createSelector(selectProductState, (state: ProductState) => state);

/** Returns the product detail array */
export const selectProductDetail = createSelector(selectProductState, (state: ProductState) => state.productDetail);

/** Returns true while a product load is in flight */
export const selectProductLoading = createSelector(selectProductState, (state: ProductState) => state.loading);

/** Returns error object from asset tag load failure, null otherwise */
export const selectProductError = createSelector(selectProductState, (state: ProductState) => state.error);
